module.exports = __webpack_public_path__ + "static/media/YB_TD_backgroundImage_icon@2x.c75b6a21.png";